// Packages

// Components
import { DevelopmentItems } from "./DevelopmentItems";

// Logic

// Context

// Services

// Styles

// Assets

export const Development = () => {
	return (
		<div className='unit-page-subpage unit-page-subpage-development'>
			<DevelopmentItems />
		</div>
	);
};
